import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Pagination from "@material-ui/lab/Pagination";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Loader from "../Global/Loader/Index";
import AlertMessage from "../../components/Global/Message/Alert";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnSearch: {
        backgroundColor: "#417557",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    cursor: {
        cursor: "pointer",
    },
    btnRed: {
        backgroundColor: "#950000",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
    },
}));

const ManageContactUsMSGs = () => {
    const classes = useStyles();
    const [pageLoading, setPageLoading] = React.useState(true);
    const [messages, setMessages] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });
    const [fullName, setFullName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [date, setDate] = useState(false);
    const [messageText, setMessageText] = useState(false);
    const [countOfMessages, setCountOfMessages] = useState({});

    const [searchValue, setSearchValue] = useState("");
    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    const handleClickOpen = (name, number, date, message) => {
        setFullName(name);
        setMobileNumber(number);
        setDate(date);
        setMessageText(message);
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false);
        setFullName("");
        setMobileNumber("");
        setDate("");
        setMessageText("");
    };

    const paginate = async (value) => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/accounts/messagesList?pageId=${value}`,
                config
            );
            if (data.status === "ok") {

                setMessages(data.data.messages);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    const deleteMessage = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            //int MessageId
            const { data } = await axios.post(
                `/api/admin/deleteMessage?pageId=${currentPage}`,
                config
            );
            if (data.status === "ok") {
                setCountOfMessages(data)
                setMessages(data.data.users);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    const getMessages = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/accounts/messagesList?pageId=1`,
                config
            )
            if (data.status === "ok") {
                setMessages(data.data.messages);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    useEffect(() => {
        getMessages();
    }, []);

    return (
        <>
            <Box borderRadius={10} mt={2} mr={2} pb={1} className={classes.grayBox}>
                <Box mt={2} mb={2} px={2} pt={2}>
                    <Box
                        bgcolor="#950000"
                        borderRadius={10}
                        color="#fff"
                        p={2}
                        textAlign="center">
                        <Grid container>
                            <Grid xs={1}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">ردیف
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    نام و نام خانوادگی
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    شماره همراه کاربر
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    تاریخ و ساعت دریافت
                                </Box>
                            </Grid>
                            <Grid xs={4}>
                                <Box justifyContent="center" alignItems="center" height="100%">
                                    متن پیام
                                </Box>
                            </Grid>
                            <Grid xs={1}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    عملیات
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {(pageLoading) ? (
                        <Box mt={3}>
                            <Loader text="در حال بارگزاری..." />
                        </Box>
                    ) : (
                        messages.length > 0 ? (
                            (messages.map((item, i) => (
                                <Box
                                    style={{ padding: "25px 15px 25px 15px" }}
                                    bgcolor="#fff"
                                    borderRadius={10}
                                    boxShadow="-4px 4px 18px rgba(0, 0, 0, 0.18)"
                                    mt={2}
                                    textAlign="center">
                                    <Grid container>
                                        <Grid xs={1}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {i + 1}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.imageURL && (
                                                    <img
                                                        src={item.imageURL}
                                                        width="30px"
                                                        height="30px"
                                                        style={{ marginLeft: "10px", borderRadius: "50%" }}
                                                    />
                                                )}
                                                {item.fullName}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.mobileNumber}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.date}
                                            </Box>
                                        </Grid>
                                        <Grid xs={4}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.text.substr(1, 40) + '...'}
                                            </Box>
                                        </Grid>
                                        <Grid xs={1}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                <a
                                                    onClick={() => {
                                                        handleClickOpen(
                                                            item.fullName,
                                                            item.mobileNumber,
                                                            item.date,
                                                            item.text
                                                        );
                                                    }}
                                                    className={classes.cursor}>
                                                    نمایش پیام
                                                </a>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )))
                        ) : (
                            <Box mt={3} mb={1}>
                                <AlertMessage variant="info">
                                    موردی جهت نمایش وجود ندارد.
                                    </AlertMessage>
                            </Box>
                        )
                    )}
                </Box>
                {/* <Box
                    display="flex"
                    justifyContent="right"
                    mt={3}
                    pr={3}
                    alignItems="center">
                    {!pageLoading && (`تعداد کل پیام ها : ${countOfMessages.data.count}`)}
                </Box> */}
                <Box
                    display="flex"
                    justifyContent="center"
                    mt={2}
                    mb={2}
                    alignItems="center">
                    <Pagination
                        count={pages}
                        page={currentPage}
                        variant="outlined"
                        shape="rounded"
                        onChange={(e, value) => {
                            setCurrentPage(value);
                            paginate(value);
                        }}
                    />
                </Box>
            </Box>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle style={{ textAlign: 'center' }} id="alert-dialog-slide-title">
                    مشاهده پیام کاربر
                </DialogTitle>
                <DialogContent style={{ minWidth: "500px" }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <Box>
                                    <strong>نام و نام خانوادگی:</strong><br />
                                    <span>{fullName}</span>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box>
                                    <strong>شماره همراه:</strong><br />
                                    <span>{mobileNumber}</span>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box>
                                    <strong>ساعت و تاریخ:</strong><br />
                                    <span>{date}</span>
                                </Box>
                            </Grid>
                            <Grid itme xs={12}>
                                <Box mt={1}>
                                    <strong>متن پیام</strong>
                                </Box>
                            </Grid>
                            <Grid itme xs={12}>
                                <Box mt={1}>
                                    {messageText}
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ManageContactUsMSGs;
